import { styled as muiStyled, Stack } from '@mui/material';

export const Wrapper = muiStyled(Stack)(() => ({
  flex: '1',
  flexDirection: 'column',
  fontFamily: 'var(--retrofit-luft-fonts)',
}));

export const Container = muiStyled(Stack)(() => ({
  flexDirection: 'column',
  marginTop: '4px',
  marginBottom: '8px',
  marginLeft: '16px',
}));
